import { useCallback, useEffect, useState } from 'react';
import { SubscribedEventEntry, SubscribedEventEntryApi } from '../Model/Coach/Schedule/SubscribedEventEntry';
import { SubscribedOfflineMeetingEventEntry, SubscribedOfflineMeetingEventEntryApi } from '../Model/Coach/Schedule/SubscribedOfflineMeetingEventEntry';
import { OfflineMeetingWaitlistEntry, OfflineMeetingWaitlistEntryApi } from '../Model/Coach/Schedule/OfflineMeetingWaitlistEntry';

export function useSubscribedEvent(objectType: string, objectId: string) {
  const [event, setEvent] = useState<SubscribedEventEntry | undefined>();

  useEffect(() => {
    if (objectType && objectId) {
      SubscribedEventEntryApi.findExisting({ objectType, objectId }).then((result) => {
        setEvent(result);
      });
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setEvent(undefined);
    }
  }, [objectType, objectId]);

  return event;
}

export function useSubscribedOfflineMeetingEvent(objectId: string) {
  const [event, setEvent] = useState<SubscribedOfflineMeetingEventEntry | undefined>();

  const load = useCallback(() => {
    SubscribedOfflineMeetingEventEntryApi.findExisting({ objectId }).then((result) => setEvent(result));
  }, [objectId]);

  useEffect(() => {
    load();
  }, [load]);

  return { event, load };
}

export function useWaitlistEntry(objectId: string) {
  const [waitlist, setWaitlist] = useState<OfflineMeetingWaitlistEntry | undefined>();

  const load = useCallback(() => {
    OfflineMeetingWaitlistEntryApi.findExisting({ objectId }).then((result) => setWaitlist(result));
  }, [objectId]);

  useEffect(() => {
    load();
  }, [load]);

  return { waitlist, load };
}
